module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2669/facility-1c608557ef90a79044550d411dea8cf1.webp";